import { Divider } from "antd";

const Dividers = (props) => {
  const { divide } = props;
  return <Divider>{divide}</Divider>;
};

export default Dividers;
